import type { ResultOf } from '@graphql-typed-document-node/core';
import type { Writable } from 'type-fest';

import { graphql } from '@e-socna/data-layer';
import type { Id, SectionTypeId } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const CompatibleSectionTemplates_SectionTemplates_QueryDocument =
  graphql(`
    query CompatibleSectionTemplates_SectionTemplates_Query(
      $alreadyUsedIds: [Id!]!
      $sectionTypeId: Id
    ) {
      findAllEnabledAndCompatibleSectionTemplates(
        alreadyUsedIds: $alreadyUsedIds
        sectionTypeId: $sectionTypeId
      ) {
        _id
        code
        label
        virtualRoot {
          orientation
          paperFormat
          hasPagebreakAfter
          hasPagebreakBefore
        }
      }
    }
  `);

export type CompatibleSectionTemplates_SectionTemplates = ResultOf<
  typeof CompatibleSectionTemplates_SectionTemplates_QueryDocument
>['findAllEnabledAndCompatibleSectionTemplates'][number];

interface Params {
  readonly alreadyUsedIds: readonly Id[];
  readonly typeId?: SectionTypeId;
  readonly enabled?: boolean;
}

export const useFindAllCompatibleSectionTemplatesQuery = ({
  alreadyUsedIds,
  typeId,
  enabled = true,
}: Readonly<Params>) =>
  useGraphQLQuery(
    CompatibleSectionTemplates_SectionTemplates_QueryDocument,
    {
      alreadyUsedIds: alreadyUsedIds as Writable<typeof alreadyUsedIds>,
      sectionTypeId: typeId,
    },
    { enabled },
  );
